<template>
  <div class="p-4">
    <!-- 总览：四张图 -->

  <div v-if="!focus" class="overview-grid">
    <div v-for="m in maps" :key="m.map_no" class="card" :data-map="m.map_no" @click="open(m.map_no)">
      <div class="thumb-wrap">
        <!-- 给每张缩略图一个独立 ref，并监听加载完成 -->
        <img :src="m.file_url" class="thumb" :ref="'thumb-'+m.map_no" @load="onThumbLoad(m.map_no)" />
        <!-- 图片未 ready 前先隐藏 overlay，避免点落到左上角 -->
        <div class="overlay overlay-readonly" :class="{ invisible: !isMapReady(m.map_no) }">
          <div v-for="mk in markersByMap(m.map_no)" :key="mk.key"
              :class="['pin', mk.db_overheat ? 'hot' : 'ok']"
              :style="pinStyle(mk, true)"
              :title="tooltipOf(mk)"  >
            <div class="dot"></div>
            <div class="val" v-if="(showTempAlways || mk.db_overheat) && mk.temp_c!=null">{{ mk.temp_c.toFixed(1) }}°C</div>
          </div>
        </div>
      </div>
      <div class="title">{{ m.title }}</div>
    </div>
  </div>

    <!-- 放大：单图 + 编辑位置 -->
    <div v-else class="relative">
            <div class="zoom-wrap">
        <!-- 放大图也加 onload 标记 ready -->
        <img :src="(focusedMap && focusedMap.file_url) || ''" class="zoom" ref="zoomImg" @load="onZoomLoad" />
        <div class="overlay overlay-zoom" :class="{ invisible: !zoomReady }">
          <div v-for="mk in markers" :key="mk.key" class="pin"
              :class="[{ hot: mk.db_overheat, editing: editMode }]"
              :style="pinStyle(mk, false)"
              @mousedown.prevent="startDrag($event, mk)"
              @touchstart.prevent="startDrag($event, mk)"
              :title="tooltipOf(mk)"  >
            <div class="dot"></div>
            <div class="lbl" v-if="editMode">#{{ mk.device_id +"-"+ mk.node_id }}</div>
            <div class="val" v-if="(showTempAlways || mk.db_overheat) && mk.temp_c!=null">{{ mk.temp_c.toFixed(1) }}°C</div>
          </div>
        </div>
      </div>
      

      <!-- 悬浮工具条（固定在右上角） -->
      <div class="toolbar-floating">
        <div class="toolbar-row">
          <button class="btn ghost" @click="focus = null" title="Back (Esc)">← Back</button>
          <div class="sep"></div>

          <label class="switch" title="Toggle Edit (E)">
            <input type="checkbox" v-model="editMode" />
            <span>Edit</span>
          </label>

          <label class="switch" title="Always show temperature">
            <input type="checkbox" v-model="showTempAlways" />
            <span>Temp label</span>
          </label>

          <button class="btn primary" :disabled="!editMode" @click="savePositions" title="Save (Ctrl+S)">Save</button>

          <div class="sep"></div>

          <span class="status-dot" :class="{ hot: hasHot, editing: editMode }"></span>
          <span class="status-text">{{ updatedLabel }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Dashboard',
  data () {
    return {
      API: '/api'+'server',
      maps: [],          // [{map_no,title,file_url}]
      sensors: [],       // 来自 sensors_current
      positions: [],     // [{map_no,device_id,node_id,x_pct,y_pct}]
      focus: null,       // 当前放大 map_no
      editMode: false,
      lastTs: 0,
      timer: null,
      showTempAlways: true,    // ✅ 新增：长显温度
      readyThumbs: {},   // { [map_no]: true }
      zoomReady: false,  // 放大图是否 ready
      ro: null,          // ResizeObserver 实例
      markers: []        // 放大页当前图用的响应式点位
    }
  },
  computed: {
    updatedLabel () {
      if (!this.lastTs) return 'more than 1 minute ago'
      const s = (Date.now() - this.lastTs) / 1000
      if (s < 10) return 'just updated'
      if (s < 60) return `updated ${Math.round(s)} seconds ago`
      if (s < 120) return 'updated 1 minute ago'
      return 'more than 1 minute ago'
    },
    focusedMap () {
      return this.maps.find(x => x.map_no === this.focus) || null
    },
    // 当前放大页是否存在告警
    hasHot () {
      if (!this.focus) return false
      return this.markers.some(m => m.db_overheat)
    }
  },
  methods: {
    _getThumb(no){
    const r = this.$refs['thumb-'+no]
    if (!r) return null
    return Array.isArray(r) ? (r[0] || null) : r
  },
     isMapReady(no){ return !!this.readyThumbs[String(no)] },

     onThumbLoad(no){
    // 标记就绪 & 监听尺寸变化
    this.$set(this.readyThumbs, String(no), true)
    const img = this._getThumb(no)
    if (img && this._ro) this._ro.observe(img)
    // 下一帧强刷，立刻重算 pinStyle
    requestAnimationFrame(() => this.$forceUpdate())
  },

    onZoomLoad(){
      this.zoomReady = true
      const img = this.$refs.zoomImg
      if (img && this._ro) this._ro.observe(img)
      requestAnimationFrame(() => this.$forceUpdate())
    },
    tooltipOf(mk){
      if (mk == null) return ''
      const t = (mk.temp_c!=null) ? `${mk.temp_c.toFixed(1)}°C` : 'N/A'
      const h = (mk.humidity!=null) ? `${mk.humidity.toFixed(0)}%` : 'N/A'
      return mk.db_overheat ? t : `${t} • ${h}`
    },
  // 进入放大页：先置 false，等 onload/complete 再显示
    open(no){
      this.focus = no
      this.zoomReady = false
      this.$nextTick(() => {
        this.buildMarkersForFocus()
        // 如果放大图已缓存完成，不等 onload，直接置 ready
        const z = this.$refs.zoomImg
        if (z && z.complete) this.onZoomLoad()
      })
    },
    keyOf (m) {
      return `${m.map_no}|${m.device_id}|${m.node_id}`
    },
    // 总览使用的只读合并（非响应式点）
    markersByMap (no) {
      const out = []
      const list = this.positions.filter(x => x.map_no === no)
      for (const p of list) {
        const s = this.sensors.find(
          y => y.device_id === p.device_id && Number(y.node_id) === Number(p.node_id)
        )
        out.push({
          key: this.keyOf(p),
          map_no: p.map_no,
          device_id: p.device_id,
          node_id: p.node_id,
          x_pct: Number(p.x_pct),
          y_pct: Number(p.y_pct),
          db_overheat: !!(s && Number(s.node_overheat)),
          temp_c:  s ? Number(s.temperature) : null,   // ✅ 新增
          humidity: s ? Number(s.humidity)    : null   // ✅ 新增
        })
      }
      return out
    },
    // 放大页用：从 positions + sensors 构建响应式 markers
    buildMarkersForFocus () {
      if (!this.focus) { this.markers = []; return }
      const list = this.positions.filter(x => x.map_no === this.focus)
      const out = []
      for (const p of list) {
        const s = this.sensors.find(
          y => y.device_id === p.device_id && Number(y.node_id) === Number(p.node_id)
        )
        out.push({
          key: this.keyOf(p),
          map_no: p.map_no,
          device_id: p.device_id,
          node_id: p.node_id,
          x_pct: Number(p.x_pct),
          y_pct: Number(p.y_pct),
          db_overheat: !!(s && Number(s.node_overheat)),
          temp_c:  s ? Number(s.temperature) : null,   // ✅ 新增
          humidity: s ? Number(s.humidity)    : null   // ✅ 新增
        })
      }
      this.markers = out
    },
    // 轮询时刷新放大页小圆点颜色
   syncHotFlagsOnMarkers () {
      if (!this.focus || !this.markers.length) return
      for (const mk of this.markers) {
        const s = this.sensors.find(
          y => y.device_id === mk.device_id && Number(y.node_id) === Number(mk.node_id)
        )
        mk.db_overheat = !!(s && Number(s.node_overheat))
        mk.temp_c  = s ? Number(s.temperature) : null     // ✅ 新增
        mk.humidity = s ? Number(s.humidity)   : null     // ✅ 新增
      }
    },
  _drawRectOfContain(imgEl) {
    const cw = imgEl.clientWidth || 1
    const ch = imgEl.clientHeight || 1
    const iw = imgEl.naturalWidth || cw
    const ih = imgEl.naturalHeight || ch
    const cr = cw / ch
    const ir = iw / ih
    // 以较小的比例缩放，得到绘制宽高
    if (ir > cr) {
      // 以宽度贴合，顶部/底部留白
      const drawW = cw
      const drawH = cw / ir
      const offX = 0
      const offY = (ch - drawH) / 2
      return { offX, offY, drawW, drawH }
    } else {
      // 以高度贴合，左右留白
      const drawH = ch
      const drawW = ch * ir
      const offX = (cw - drawW) / 2
      const offY = 0
      return { offX, offY, drawW, drawH }
    }
  },

  pinStyle(mk, isThumb){
    if (isThumb){
      const img = this._getThumb(mk.map_no)
      if (!img) return { visibility: 'hidden' }
      // 若图片还没布局完成（宽高为0），先隐藏，等下一帧再刷
      if (!this.isMapReady(mk.map_no) || !img.clientWidth || !img.clientHeight) {
        return { visibility: 'hidden' }
      }
      const { offX, offY, drawW, drawH } = this._drawRectOfContain(img)
      const x = offX + (mk.x_pct/100)*drawW
      const y = offY + (mk.y_pct/100)*drawH
      return { transform: `translate(${x-6}px,${y-6}px)` }
    } else {
      const img = this.$refs.zoomImg
      if (!img || !this.zoomReady || !img.clientWidth || !img.clientHeight) {
        return { visibility: 'hidden' }
      }
      const w = img.clientWidth, h = img.clientHeight
      const x = (mk.x_pct/100)*w
      const y = (mk.y_pct/100)*h
      return { transform: `translate(${x-6}px,${y-6}px)` }
    }
    },
    async loadAll () {
      const [m, p, s] = await Promise.all([
        axios.get(`${this.API}/get_maps.php`),
        axios.get(`${this.API}/get_positions.php`),
        axios.get(`${this.API}/get_sensors.php`)
      ])
      this.maps = m.data.data || []
      this.positions = p.data.data || []
      this.sensors = s.data.data || []
      this.lastTs = Date.now()
      if (this.focus) this.buildMarkersForFocus()
    },
    async loadSensorsOnly () {
      const s = await axios.get(`${this.API}/get_sensors.php`)
      this.sensors = s.data.data || []
      this.lastTs = Date.now()
      this.syncHotFlagsOnMarkers()
    },
    startDrag (e, mk) {
      if (!this.editMode) return
      const img = this.$refs.zoomImg
      if (!img) return
      const rect = img.getBoundingClientRect()
      const getXY = (ev) => {
        const t = ev.touches ? ev.touches[0] : ev
        return { x: t.clientX - rect.left, y: t.clientY - rect.top, w: rect.width, h: rect.height }
      }
      const move = (ev) => {
        const { x, y, w, h } = getXY(ev)
        mk.x_pct = Math.max(0, Math.min(100, (x / w) * 100))
        mk.y_pct = Math.max(0, Math.min(100, (y / h) * 100))
      }
      const up = () => {
        window.removeEventListener('mousemove', move)
        window.removeEventListener('mouseup', up)
        window.removeEventListener('touchmove', move)
        window.removeEventListener('touchend', up)
      }
      window.addEventListener('mousemove', move)
      window.addEventListener('mouseup', up)
      window.addEventListener('touchmove', move, { passive: false })
      window.addEventListener('touchend', up)
    },
    async savePositions () {
      if (!this.focus) return
    const round4 = v => Math.round(v * 1e4) / 1e4
    const payload = {
      map_no: this.focus,
      positions: this.markers.map(m => ({
        device_id: m.device_id,
        node_id: m.node_id,
        x_pct: round4(Math.max(0, Math.min(100, m.x_pct))),
        y_pct: round4(Math.max(0, Math.min(100, m.y_pct)))
      }))
    }

    await axios.post(`${this.API}/save_positions.php`, payload, {
      headers: { 'Content-Type': 'application/json' } // ✅ 关键
    })

      this.editMode = false
      // 同步回 positions，避免返回再进时丢失
      for (const m of this.markers) {
        const idx = this.positions.findIndex(x =>
          x.map_no === this.focus && x.device_id === m.device_id && Number(x.node_id) === Number(m.node_id)
        )
        if (idx >= 0) {
          this.$set(this.positions, idx, {
            ...this.positions[idx],
            x_pct: m.x_pct, y_pct: m.y_pct
          })
        }
      }
    },

    _onKeydown (e) {
      if (e.key === 'Escape') { this.focus = null; return }
      if (e.key && e.key.toLowerCase() === 'e') { this.editMode = !this.editMode; return }
      if ((e.ctrlKey || e.metaKey) && e.key && e.key.toLowerCase() === 's') {
        if (this.editMode) { e.preventDefault(); this.savePositions() }
      }
    }
  },
  async mounted () {
    document.body.classList.add('hide-sidebar');     // 进入页面隐藏
      if (window.ResizeObserver){
      this.ro = new ResizeObserver(() => this.$forceUpdate())
    }
    this.loadAll().then(()=>{
      this.timer = setInterval(this.loadSensorsOnly, 3000)
    })
    window.addEventListener('keydown', this._onKeydown)
  },
  beforeDestroy () {
    document.body.classList.remove('hide-sidebar');  // 退出页面恢复
     if (this.timer) clearInterval(this.timer)
      if (this.ro){ try{ this.ro.disconnect() }catch(e){void 0} this.ro=null }
      window.removeEventListener('keydown', this._onKeydown)
  }
}
</script>

<style scoped>

/* === 总览：2×2 自动铺满屏 === */
.overview-grid{
  height: calc(100vh - 96px);   /* 顶部有导航的话按需调这个值 */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows:    repeat(2, 1fr);
  gap: 16px;
}

/* 卡片本身占满各格子 */
.card{
  position: relative;
  border:1px solid #e5e7eb;
  border-radius:14px;
  overflow:hidden;
  background:#fff;
  display:flex;
  flex-direction:column;
}

.invisible{ opacity: 0; }
.overlay{ transition: opacity .15s ease; }  /* 点位区域淡入 */

.thumb-wrap{ position:relative; flex:1 1 auto; width:100%; height:100%; background:#f8fafc; }
.thumb{ width:100%; height:100%; object-fit:contain; display:block; } /* 总览等比显示全图 */
.overlay-readonly{ pointer-events:none; }   /* 总览层不拦截点击 */

/* 覆盖层基类：铺满容器 */
.overlay{ position:absolute; inset:0; }

/* 放大页用交互层：要能接收拖拽事件 */
.overlay-zoom{ pointer-events: auto; }

/* 传感器点位（保持你的样式） */
.pin{ position:absolute; transform-origin:center; pointer-events:auto; }
.dot{ width:18px; height:18px; border-radius:9999px; background:#10b981;
      box-shadow:0 0 0 2px #fff,0 0 0 3px rgba(0,0,0,.25); }
.pin.hot .dot{ background:#dc2626; animation:blink .9s infinite alternate; }
@keyframes blink{ from{opacity:.45} to{opacity:1} }

/* 卡片标题放底部角落即可 */
.title{
  position:absolute; right:10px; bottom:10px;
  background:rgba(255,255,255,.85);
  font-size:12px; padding:2px 8px; border-radius:6px;
}

/* 放大页原来的样式保留（zoom-wrap/zoom 等） */

/* 布局与卡片 */
.grid{display:grid}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.gap-4{gap:1rem}


.lbl{margin-top:2px;font-size:11px;background:rgba(255,255,255,.85);padding:0 4px;border-radius:4px;box-shadow:0 0 0 1px rgba(0,0,0,.1)}

.val{
  position: absolute;
  left: -10px; margin-top: 2px;                 /* 点右侧 */
  font-size: 12px; line-height: 1;
  padding: 2px 6px;
  border-radius: 6px;
  white-space: nowrap;
  backdrop-filter: blur(2px);

  /* 中性配色（正常/非报警） */
  color: #334155;                                   /* slate-700 */
  background: rgba(148,163,184,.15);                /* slate-400/15% */
  border: 1px solid rgba(51,65,85,.30);             /* slate-700/30% */
}

/* 仅过热时变红并加粗 */
.pin.hot .val{
  color: #dc2626;
  background: rgba(220,38,38,.10);
  border-color: rgba(220,38,38,.35);
  font-weight: 600;
}

/* 标题与画布 */

.zoom-wrap{position:relative;max-width:1200px}
.zoom{display:block;width:100%;height:auto;border:1px solid #e5e7eb;border-radius:12px}

/* ===== 悬浮工具条 ===== */
.toolbar-floating{
  position: fixed;
  top: 82px;                 /* 视口上边距，按你的顶部导航高度适配 */
  right: 24px;
  z-index: 2000;
  pointer-events: none;
}
.toolbar-row{
  pointer-events: auto;
  display: flex; align-items: center; gap: 10px;
  padding: 8px 12px;
  border-radius: 12px;
  border: 1px solid rgba(0,0,0,.08);
  background: rgba(255,255,255,.65);
  box-shadow: 0 8px 24px rgba(0,0,0,.12);
  backdrop-filter: blur(8px);
}
.btn{ border:1px solid #d1d5db; border-radius:8px; padding:6px 12px; background:#fff; cursor:pointer; }
.btn:hover{ box-shadow:0 2px 6px rgba(0,0,0,.08); }
.btn:disabled{ opacity:.5; cursor:not-allowed; }
.btn.primary{ border-color:#2563eb; background:#2563eb; color:#fff; }
.btn.primary:hover{ filter:brightness(1.05); }
.btn.ghost{ background:rgba(255,255,255,.9); }
.sep{ width:1px; height:20px; background:rgba(0,0,0,.1); }
.switch{ display:flex; align-items:center; gap:6px; font-size:14px; user-select:none; }
.switch input{ transform: translateY(1px); }
.status-dot{
  width:10px; height:10px; border-radius:9999px;
  background:#10b981;
  box-shadow:0 0 0 2px #fff, 0 0 0 3px rgba(0,0,0,.15);
}
.status-dot.hot{ background:#dc2626; animation: blink 0.9s infinite alternate; }
.status-dot.editing{ box-shadow:0 0 0 2px #fff, 0 0 0 3px rgba(37,99,235,.35); }
.status-text{ font-size:12px; opacity:.7; }

/* 暗色适配（可选） */
@media (prefers-color-scheme: dark){
  .toolbar-row{
    background: rgba(30,41,59,.55);
    border-color: rgba(148,163,184,.18);
    color: #e2e8f0;
  }
  .btn{ background:#0f172a; color:#e2e8f0; border-color:#334155; }
  .btn.ghost{ background:#0f172a; }
  .sep{ background:rgba(148,163,184,.25); }
}
</style>
